var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchiveBoxLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.5C1.44772 3.5 1 3.94772 1 4.5V5.5C1 6.05228 1.44772 6.5 2 6.5H18C18.5523 6.5 19 6.05228 19 5.5V4.5C19 3.94772 18.5523 3.5 18 3.5H2Z",
    fill: "#818181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8H18L17.1885 15.7094C17.0813 16.7273 16.223 17.5 15.1995 17.5H4.80052C3.77701 17.5 2.91866 16.7273 2.81151 15.7094L2 8ZM7 11.5C7 10.9477 7.44772 10.5 8 10.5H12C12.5523 10.5 13 10.9477 13 11.5C13 12.0523 12.5523 12.5 12 12.5H8C7.44772 12.5 7 12.0523 7 11.5Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveBoxLight);
export default __webpack_public_path__ + "static/media/archive-box-light.953d3ac1ffe4ae987fb20a9d85ee750f.svg";
export { ForwardRef as ReactComponent };